export function containsOnlyOne<T>(array?: T[] | null): array is [T] {
  return Array.isArray(array) && array.length === 1
}

export type MinLengthArray<T, N extends number, Current extends T[] = []> = Current['length'] extends N
  ? [...Current, ...T[]]
  : MinLengthArray<T, N, [...Current, T]>

/**
 * Type guard that makes sure the array has a minimum length
 * @example
 * ```ts
 * const array: string[] = []
 * if (containsAtLeast(1)(array)) {
 *   const first = array[0] // first is `string` and not `string | undefined`
 * }
 * ```
 */
export const containsAtLeast = <Min extends number>(min: Min) => {
  return <T>(array: T[]): array is MinLengthArray<T, Min> => array.length >= min
}
